import React, { useState } from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Divider, Modal, PillButton, Row, TextButton } from 'library/ui';
import TandemLogo from 'assets/images/NavyLogo.svg';
import UserAttributesApi from 'shared/UserAttributesApi';
import { useUserContext } from 'UserContext';
import { ValuePropsStep } from './ValuePropsStep';
import { HowItWorksStep } from './HowItWorksStep';
import { GetStartedStep } from './GetStartedStep';

const TOTAL_STEPS = 3;
const LAST_STEP = TOTAL_STEPS - 1;

export function WelcomeModal({ open, onClose }: { open: boolean; onClose: () => void }) {
    const [step, setStep] = useState<number>(0);
    const { user, refreshAlreadyLoggedInUser } = useUserContext();

    function closeModal() {
        if (user?.welcome_attribute) {
            UserAttributesApi.remove(user.welcome_attribute.id).then(refreshAlreadyLoggedInUser);
        }
        onClose();
    }

    if (!open) {
        return null;
    }

    const next = () => setStep((s) => Math.min(LAST_STEP, s + 1));
    const back = () => setStep((s) => Math.max(0, s - 1));

    return (
        <Modal id="welcome-modal" onClose={closeModal} width={640} headerBar={<TandemLogo style={{ height: 40 }} />}>
            {step === 0 && <ValuePropsStep />}
            {step === 1 && <HowItWorksStep />}
            {step === 2 && <GetStartedStep />}
            <Divider />
            <Row justify="between" fullWidth>
                <Row gap="sm">
                    {Array.from({ length: TOTAL_STEPS }, (_, i) => (
                        <Dot
                            key={i}
                            style={{
                                width: i === step ? 22 : 8,
                                backgroundColor: i === step ? Colors.secondary : Colors.border,
                            }}
                        />
                    ))}
                </Row>
                <Row gap="sm">
                    {step === 0 && <TextButton onClick={closeModal}>Skip tour</TextButton>}
                    {step > 0 && (
                        <PillButton variant="secondary" onClick={back}>
                            Back
                        </PillButton>
                    )}
                    {step < LAST_STEP && (
                        <PillButton id="welcome-modal-next-button" onClick={next}>
                            Next
                        </PillButton>
                    )}
                    {step === LAST_STEP && (
                        <PillButton id="welcome-modal-get-started-button" onClick={closeModal}>
                            Get Started
                        </PillButton>
                    )}
                </Row>
            </Row>
        </Modal>
    );
}

const Dot = styled('div')({
    height: 8,
    borderRadius: 70,
    transition: 'width 0.2s ease, background-color 0.2s ease',
});
